import { z } from 'zod'

/**
 * The structured field errors a failed Zod parse carries.
 *
 * This is the shape `ZodError.flatten()` already produces. It lives next to
 * the error body so the API that throws it and the client that reads it
 * cannot describe it differently.
 */
export const apiErrorDetailsSchema = z.object({
  formErrors: z.array(z.string()),
  fieldErrors: z.record(z.string(), z.array(z.string())),
})

export type ApiErrorDetails = z.infer<typeof apiErrorDetailsSchema>

/**
 * The JSON body of a failed API response.
 *
 * Nest adds `statusCode` and `error` around an `HttpException`. Validation
 * adds `details`. `message` stays one string: the validation pipe joins
 * every issue into a single sentence before it throws. A body that is not
 * this shape is not parsed here; the client keeps the raw text as `message`.
 */
export const apiErrorBodySchema = z.object({
  message: z.string().optional(),
  error: z.string().optional(),
  statusCode: z.number().optional(),
  details: apiErrorDetailsSchema.optional(),
})

export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>
